import { Component, Input, OnInit, ElementRef } from '@angular/core';
import { APPCONFIG } from "app/config";
import { TranslateService } from '@ngx-translate/core';
import { Menu } from '../../../models/menu';

@Component({
  selector: 'my-app-sidenav-menu',
  styles: [],
  templateUrl: './sidenav-menu.component.html'
})

export class AppSidenavMenuComponent implements OnInit {
  menus: any = [];
  AppConfig;
  filtro: string = '';

  constructor(private elRef: ElementRef, private translate: TranslateService) {
  }
  ngOnInit() {
    this.AppConfig = APPCONFIG;

    this.adicionarMenus();
  }

  adicionarMenus() {
    this.menus = [
      new Menu(1, 'Home', 'home', '/app/home', '', false, null),
      new Menu(2, 'menu.meuCadastro', 'account_box', '/app/devedor/editar', '', false, null),      
    ];
  }

  applyFilter(filter: string): any {
    if (filter.length < 3) {
      this.adicionarMenus();
    }
    else {
      this.menus = this.menus.filter(item => {
        if (item.SubMenus != null) {
          item.SubMenus = item.SubMenus.filter(submenu => {
            return (submenu.name.toString().toLowerCase().indexOf(filter.toLowerCase()) !== -1)
          });
        }
        return ((item.name.toString().toLowerCase().indexOf(filter.toLowerCase()) !== -1) || (item.SubMenus != null && item.SubMenus.length > 0))
      });
      this.expandirAll();
    }
  }

  expandirAll() {
    const target = this.elRef.nativeElement.querySelector('.nav');

    for (var children of target.children) {
      $(children).click();
    }
  }

  exibirMenu() {    
    var result = localStorage.getItem('loginWizard') == "false" ? true : false;
    return result;
  }
}



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/layout/sidenav/sidenav-menu/sidenav-menu.component.ts